module.exports = __webpack_public_path__ + "static/media/Quest-Heroes_and_Horrors.fa61a14b.png";